import app from './components/app';

Vue.config.debug = true;

new Vue(app);


/** WEBPACK FOOTER **
 ** D:/coffce/vue-chat/src/main.js
 **/